import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconButton from '../../ui/common/common/icon_button/icon_button.jsx'
import { clearfix, listBgColor, listBorderColor } from '../common.js'

const ActionWrap = styled.div`
  display: none;
  height: 22px;
  left: -10px;
  margin-top: -13px;
  position: absolute;
  top: 50%;
  width: 22px;
  z-index: 10;
`

const Row = styled.div`
  ${clearfix}
  background: ${listBgColor};
  border-bottom: 1px solid ${listBorderColor};
  min-height: 56px;
  width: 100%;
  position: relative;

  &:hover {
    border-bottom: 1px solid $list-border-hover-color;

    > ${ActionWrap} {
      display: inline-block;
    }
  }
`

const Rows = ({ actionIcon, objectList, onActionClick, renderContent }) => {
  return objectList.map((obj, idx) => {
    return (
      <Row key={idx} className='listrow'>
        {actionIcon && (
          <ActionWrap>
            <IconButton icon={actionIcon} size='small' onClick={() => onActionClick(obj)} />
          </ActionWrap>
        )}
        {renderContent(obj, false)}
      </Row>
    )
  })
}

Rows.propTypes = {
  actionIcon: PropTypes.string,
  objectList: PropTypes.array,
  onActionClick: PropTypes.func,
  renderContent: PropTypes.func
}

Rows.defaultProps = {
  onActionClick: () => {}
}

export default Rows
